export const iamAccountRawPassword = {
  type: "string",
  minLength: 1,
  maxLength: 255
};
